import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addAvatar: {
		id: 'servicedesk-insight-object-view.header.icon-edit-dialog.add-avatar',
		defaultMessage: 'Add avatar',
		description: 'Button text label for a button opens the object icon picker dialog.',
	},
	editAvatar: {
		id: 'servicedesk-insight-object-view.header.icon-edit-dialog.edit-avatar',
		defaultMessage: 'Edit avatar',
		description: 'Button text label for a button opens the object icon picker dialog.',
	},
	removeAvatar: {
		id: 'servicedesk-insight-object-view.header.icon-edit-dialog.remove-avatar',
		defaultMessage: 'Remove avatar',
		description: 'Button text label for a button opens the object icon picker dialog.',
	},
	removeSuccessFlagTitle: {
		id: 'servicedesk-insight-object-view.header.icon-edit-dialog.remove-success-flag-title',
		defaultMessage: 'Avatar removed',
		description:
			'Success notification title shown to the user after successfully removing the avatar from an object',
	},
	removeFailFlagTitle: {
		id: 'servicedesk-insight-object-view.header.icon-edit-dialog.remove-fail-flag-title',
		defaultMessage: 'Failed to remove avatar',
		description:
			'Success notification title shown to the user after successfully removing the avatar from an object',
	},
	removeFailFlagDescription: {
		id: 'servicedesk-insight-object-view.header.icon-edit-dialog.remove-fail-flag-description',
		defaultMessage: 'Please check your connection and try again',
		description:
			'Success notification title shown to the user after successfully removing the avatar from an object',
	},

	genericErrorMessageTitle: {
		id: 'servicedesk-insight-object-view.header.icon-edit-dialog.generic-error-message-title',
		defaultMessage: "We couldn't upload the image",
		description: 'Error message title shown when a user fails to upload an image',
	},
	genericErrorMessageDescription: {
		id: 'servicedesk-insight-object-view.header.icon-edit-dialog.generic-error-message-description',
		defaultMessage: 'Refresh the page and try again',
		description: 'Error message description shown when a user fails to upload an image',
	},
	successFlagTitle: {
		id: 'servicedesk-insight-object-view.header.icon-edit-dialog.success-flag-title',
		defaultMessage: 'Avatar added',
		description:
			'Success notification title shown to the user after successfully adding avatar to the object',
	},
	avatarLabel: {
		id: 'servicedesk-insight-object-view.header.icon-edit-dialog.avatar-label',
		defaultMessage: 'Object avatar',
		description: 'Label for avatar element',
	},
});
